import script from "./HTpvpGameSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./HTpvpGameSetting.vue?vue&type=script&setup=true&lang=js"

import "./HTpvpGameSetting.vue?vue&type=style&index=0&id=6871630e&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6871630e"]])

export default __exports__